import * as React from "react";
import { useState } from "react";
import Form from "../commons/components/form/Form";
import SelectInput from "../commons/components/form/input/SelectInput";
import TextInput from "../commons/components/form/input/TextInput";
import { maxLength, required } from "../commons/model/form/Validators";
import RichTextEditorInput from "../commons/components/form/input/RichTextEditorInput";
import EmailActivityAction from "../patient-management/EmailActivityAction";
import sfetch from "../commons/utils/super-fetch";
import InputState from "../commons/model/form/InputState";
import Option from "../commons/model/Option";
import SendEmailConfirmation from "./SendEmailConfirmation";
import "./AddEmailActivity.scss";
import { sanitize } from "../commons/utils/sanitize";
import { decode } from "html-entities";

export default function AddEmailActivity({
  action,
  close,
}: {
  action: EmailActivityAction;
  close: () => any;
}) {
  const [displayEmailSentMessage, setDisplayEmailSentMessage] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const sendEmail = async (form: { [key: string]: InputState }) => {
    const payload = {
      subject: form.subject.value,
      message: form.message.value,
    };
    try {
      await sfetch(action.sendEmailUrl, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
      });
      setDisplayEmailSentMessage(true);
      window.setTimeout(() => {
        close();
      }, 10000);
    } catch (error) {
      setErrorMessage(i18n["Global.Status.technical_error"]);
      throw error;
    }
  };
  const templateOptions: Option[] = action.emailTemplates.map(
    (template) => new Option(template.uid, template.name)
  );

  return (
    <>
      {displayEmailSentMessage ? (
        <SendEmailConfirmation />
      ) : (
        <Form
          submitLabel={i18n["Activity.Action.Email.Send"]}
          submit={sendEmail}
          generalErrorMsg={errorMessage}
          secondaryActionLabel={i18n["Activity.Action.Email.Cancel"]}
          secondaryAction={close}
          secondaryActionClassName="danger"
          onUpdate={(changedInput, form) => {
            if (changedInput.name === "user-email-templates") {
              let template = action.emailTemplates.find((tpl) => tpl.uid === changedInput.value);
              template && form.subject?.setValue(sanitize(decode(template.subject)));
              template && form.message?.setValue(sanitize(template.content));
            }
          }}
        >
          <SelectInput
            options={templateOptions}
            name="user-email-templates"
            placeholder={i18n["Activity.Action.Email.EmailTemplate.SelectTemplate"]}
            label={i18n["Activity.Action.Email.EmailTemplate.Template"]}
            detail={i18n["Global.OptionalField"]}
          />
          <TextInput
            name="subject"
            placeholder={i18n["Activity.Action.Email.EmailTemplate.Subject"]}
            label={i18n["Activity.Action.Email.EmailTemplate.Subject"]}
            validators={[maxLength("", action.emailSubjectMaxLength), required()]}
          />
          <RichTextEditorInput
            name="message"
            label={i18n["Activity.Action.Email.EmailTemplate.Content"]}
            className="email-content"
            cssUrl={action.cssUrl}
            height="22rem"
            maxSize={action.emailContentMaxLength}
            validators={[required()]}
            quickLinks={action}
          />
        </Form>
      )}
    </>
  );
}
